import PropTypes from "prop-types";
import { isClose } from "helpers/isClose";
import Title from "components/shared/stays/Title";
import Text from "components/shared/stays/Text";
import styles from "components/shared/stays/Cancellation.module.scss";

export default function Cancellation({
  policy,
  bookingStartDate = null,
  showHeader = true,
  headerText = "Cancellation policy",
  title = false,
}) {
  const dynamicPolicy =
    bookingStartDate && isClose(bookingStartDate) ? "close" : policy;

  function mapPolicyText(p) {
    switch (p ? p.toLowerCase() : null) {
      case "close":
        return "Cancel and get a full refund under extenuating circumstances within 72 hours of the start date.";
      case "flexible":
        return "Cancel and get a full refund within 48 hours of purchase, or at least 30 days before the trip starts.";
      case "strict":
        return "Cancel and get a full refund within 48 hours of purchase, or at least 90 days before the trip starts.";
      default:
        return "Cancel and get a full refund within 48 hours of purchase, or at least 30 days before the trip starts.";
    }
  }

  return (
    <div className={styles.component}>
      {showHeader && (
        <div className={styles.header}>
          {title ? (
            <Title size={5}>{headerText}</Title>
          ) : (
            <Text>
              <strong>{headerText}</strong>
            </Text>
          )}
        </div>
      )}
      <Text>{mapPolicyText(dynamicPolicy)}</Text>
      <Text className={styles.link}>
        <a
          href="https://www.notion.so/withthermal/Cancellation-policy-6c54eed9907c43a0a41f2b5e9094b30e"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </a>
      </Text>
    </div>
  );
}

Cancellation.propTypes = {
  policy: PropTypes.string.isRequired,
  showHeader: PropTypes.bool,
  headerText: PropTypes.string,
  title: PropTypes.bool,
  bookingStartDate: PropTypes.string,
};
